import Router from 'next/router';
import { useStateValue } from '../../state/stateProvider';
import { goToDashboard } from '../../utils/navigation-utils';

import styles from './NotFound.module.scss';

const NotFound = () => {
  const [{ user }] = useStateValue();

  const redirect = () => {
    if (!user?.userId) {
      Router.push('/auth/login');
    } else {
      goToDashboard();
    }
  };

  return (
    <div className={styles.container}>
      <img src="/not-found.webp" alt="not found" className={styles.notFoundImage} />
      <h2 className={styles.title}>Whoops! (404)</h2>
      <p className={styles.description}>We can’t find the page you’re looking for.</p>
      <button className={styles.ctaButton} onClick={redirect}>
        Take me back home
      </button>
    </div>
  );
};

export default NotFound;
